<template>
  <div class="lp-contents">
    <div class="wrap">
      <!-- メインビジュアル -->
      <main-visual :signup-url="signupUrl" @link="link"/>


      <!-- おすすめLPへ -->
      <recommend-lp />

      <!-- HOKATOTO 全員の豪華占い -->
      <hokatoto-all :is-subscr-enable="isSubscrEnable" @link="link"/>

      <!-- <additional-counselors
        :additional-counselors="additionalCounselors"
        @click="tagId => onTagItemClick(tagId, 'additionalCounselor')"
      /> -->

      <img :src="`${path}point_1.png`" alt="point1" class="point1">

      <tag-cloud
        :tag-cloud="tagCloud"
        @click="tagId => onTagItemClick(tagId, 'tagCloud')"
      />

      <img :src="`${path}point_2.png`" alt="point2" class="point2">

      <!-- 新着メニュー -->
      <!--
      <new-arrival-menus
        class="new-menus"
        parent-page="nonmember"
        :section-data="sectionsData.newMenu"
        :is-subscr-enable="isSubscrEnable"
        :subsc-url="subscUrl"
      />
      -->

      <img :src="`${path}point_3.png`" alt="point3" class="point3">

      <cta-middle :link="signupUrl" @link="link('subsc2')" />

      <img :src="`${path}voice.png`" alt="voice" class="voice">

      <img :src="`${path}benefits.png`" alt="benefits" class="benefits">

      <cta-bottom :link="signupUrl" class="btn2" @link="link('subsc3')"/>

    </div>
  </div>
</template>

<script>
import * as types from '@/utvStore/store/mutation-types'
import FixedBackground from '@/utvStore/components/partials/FixedBackground'
import NewArrivalMenus from '@/utvStore/components/Toppage/section/NewArrivalMenus'
import MainVisual from '@/utvStore/components/Toppage/section/MainVisual'
import RecommendLp from '@/utvStore/components/Toppage/section/RecommendLp'
import HokatotoAll from '@/utvStore/components/Toppage/section/HokatotoAll'
// import AdditionalCounselors from '@/utvStore/components/Toppage/section/AdditionalCounselors'
import TagCloud from '@/utvStore/components/Toppage/section/TagCloud'
// import PointMeny from '@/utvStore/components/Toppage/section/PointMeny'
// import PointDaily from '@/utvStore/components/Toppage/section/PointDaily'
// import PointSelect from '@/utvStore/components/Toppage/section/PointSelect'
import CtaMiddle from '@/utvStore/components/Toppage/section/CtaMiddle'
// import CustomerVoice from '@/utvStore/components/Toppage/section/CustomerVoice'
// import LpBenefits from '@/utvStore/components/Toppage/section/LpBenefits'
import CtaBottom from '@/utvStore/components/Toppage/section/CtaBottom'
import LinkButton from '@/utvStore/components/partials/LinkButton'
import {TagInfo} from '@/CONSTS/SUBSCRIPTION'

export default {
  name: 'LandingPageContents',
  components: {
    LinkButton,
    FixedBackground,
    NewArrivalMenus,
    MainVisual,
    // PointMeny,
    // PointDaily,
    // PointSelect,
    CtaMiddle,
    // CustomerVoice,
    // LpBenefits,
    CtaBottom,
    RecommendLp,
    HokatotoAll,
    // AdditionalCounselors,
    TagCloud,
  },
  props: {
    userProfile: {
      type: Object,
      default() {
        return {}
      }
    },
    receiveSectionsData: {
      type: Object,
      default() {
        return {}
      }
    },
    isSubscrEnable: {
      type: Boolean,
      require: true,
    },
    subscUrl: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      path: '/static/img/toppage/lp/',
      linkBtnFace: '無料で占ってみる',
      signupUrl: '/user/input',
      sectionsData: {},
      gaEvent: {
        subsc1: {
          event_category: 'TV-top-subsc-button',
          event_label: 'point1',
        },
        subsc2: {
          event_category: 'TV-top-subsc-button',
          event_label: 'point2',
        },
        subsc3: {
          event_category: 'TV-top-subsc-button',
          event_label: 'point3',
        },
        login: {
          event_category: 'TV-top-login-button',
          event_label: '1',
        },
        dlaxueMenu: {
          event_category: 'TV-top-deluxe-menu',
          event_label: '10001',
        },
        dlaxueFree: {
          event_category: 'TV-top-deluxe-free-shindan',
          event_label: '10001',
        },
      },
    }
  },
  computed: {
    additionalCounselors(){
      return TagInfo.nonMemberLp('additionalCounselors')
    },
    tagCloud(){
      return TagInfo.nonMemberLp('tagCloud')
    }
  },
  created(){
    this.$store.dispatch(types.IS_LP, true)
  },
  mounted() {
    // 背景を強制変更
    // document.querySelector('.fixed-bg-base').style.opacity = 0.2

    if(!!this.userProfile){
      this.signupUrl = '/subsc/join'
    }
    // this.setButtonStyle()
    this.setSectionsData(this.receiveSectionsData)
  },
  methods: {
    onTagItemClick(tagId, listName) {
      console.log('tagId[%s]おした(%s) "/tag/%s"に遷移する', tagId, listName, tagId)
      window.gtag('event', 'click', {
        'event_category': 'TV-top-tag',
        'event_label': tagId
      })
      location.href = `/preview/${tagId}`
    },
    link(target) {
      event.preventDefault()
      window.gtag('event', 'click', this.gaEvent[target])
      location.href = event.currentTarget.href
    },
    setSectionsData: function (rcv) {
      if (rcv != null) {
        this.sectionsData = {}

        // <<< 新着メニュー >>>
        if (rcv.newMenu != null) {
          const rtn = []

          for (let key in rcv.newMenu) {
            rtn.push({
              ...rcv.newMenu[key],
            })
          }

          rtn.sort((a, b) => {
            const aDate = new moment(a.openedAt)
            const bDate = new moment(b.openedAt)
            if (aDate.isBefore(bDate)) return 1;
            if (aDate.isAfter(bDate)) return -1;
            return 0;
          })
          this.sectionsData['newMenu'] = rtn
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.lp-contents {
  padding: 44px 0 60px;
  margin: -44px auto -50px;
  color: $col_base_black;
  background: url('') no-repeat center top;
  background-size: 100% auto;
  img {
    display: block;
    width: 100%;
  }
  .wrap {
    position: relative;
  }
  .point1 {
    margin: 14.4% 0 6.4%;
  }
  .point2 {
    margin: 12.8% 0 6.4%;
  }
  .new-menus {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .point3 {
    margin: 12.8% 0;
  }
  .voice {
    margin: 17.066% 0 11.733%;
  }
  .benefits {
    margin: 11.733% 0 0;
  }

  .link-button,
  /deep/ .link-button {
    display: block;
    font-size: unquote('min(4.266vw, 26px)');
    padding: unquote('min(4vw, 23px)') 0;
    border-radius: 100px;
  }
  .link-button--ghost {}
}
</style>





// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Toppage/LandingPageContents.vue